export default __webpack_public_path__ + "static/media/slider1.804ad224.jpg";